var WINDOW_RESIZE_DEBOUNCE = 50;
var debounceTimes = {
  WINDOW_RESIZE_DEBOUNCE: WINDOW_RESIZE_DEBOUNCE
};

export default debounceTimes;
export { WINDOW_RESIZE_DEBOUNCE };
